var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-transparent",attrs:{"type":"button"},on:{"click":_vm.share}},[_c('share-icon'),_c('span',{staticClass:"small"},[_vm._v("Share")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }